import React, { Component } from "react";
import {
  FacebookShareButton,
  GooglePlusShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  TelegramShareButton,
  WhatsappShareButton,
  PinterestShareButton,
  VKShareButton,
  OKShareButton,
  RedditShareButton,
  TumblrShareButton,
  LivejournalShareButton,
  ViberShareButton,
  EmailShareButton
} from "react-share";
import {
  FacebookIcon,
  TwitterIcon,
  TelegramIcon,
  WhatsappIcon,
  GooglePlusIcon,
  LinkedinIcon,
  PinterestIcon,
  VKIcon,
  OKIcon,
  RedditIcon,
  TumblrIcon,
  LivejournalIcon,
  MailruIcon,
  EmailIcon,
  ViberIcon
} from "react-share";
export default class Sharers extends Component {
  render() {
    var url = window.location.href;
    var title = this.props.post
      ? "#CompromisosDePeña | " + this.props.post.title
      : "#CompromisosDePeña | Peña Nieto firmó. ¿Cumplió?";
    return (
      <div className="sharers">
        <div className="share-td" style={{ backgroundColor: "#3b5998" }}>
          <FacebookShareButton url={url}>
            <FacebookIcon />
          </FacebookShareButton>
        </div>
        <div className="share-td" style={{ backgroundColor: "white" }}>
          <TwitterShareButton url={url} title={title} via={"pajaropolitico"}>
            <TwitterIcon />
          </TwitterShareButton>
        </div>
        <div className="share-td" style={{ backgroundColor: "#2cb742" }}>
          <WhatsappShareButton url={url}>
            <WhatsappIcon />
          </WhatsappShareButton>
        </div>
        <div className="share-td" style={{ backgroundColor: "#37aee2" }}>
          <TelegramShareButton url={url} title={title}>
            <TelegramIcon />
          </TelegramShareButton>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/sharers.js